import React from "react";
import PropTypes from "prop-types";
import ToolsNewWebinar from "./ToolsNewWebinar.jsx";
import FiltersNewWebinar from "./FiltersNewWebinar";

function ToolbarNewWebinar({ toolsProps, filterProps }) {
  return (
    <div>
      <ToolsNewWebinar {...toolsProps} />
      <FiltersNewWebinar {...filterProps} />
    </div>
  );
}

ToolbarNewWebinar.defaultProps = {};

ToolbarNewWebinar.propTypes = {
  filterProps: PropTypes.object,
  toolsProps: PropTypes.object,
};

export default ToolbarNewWebinar;



// WEBPACK FOOTER //
// ./src/components/AddUsersWebinar/index.jsx